import React, { ReactNode, useContext, useEffect, useState } from 'react';

import QueueTotalsContext from '@totem/components/ticketing/queueTotals/QueueTotalsContext';
import { QueueSummary } from '@totem/components/ticketing/queueTotals/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
};
const QueueTotalsContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<QueueSummary[]>([]);
  useEffect(() => {
    setIsLoading(true);

    fetch(`${TICKETS_ENDPOINT}/queue/totals`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: QueueSummary[]) => {
        setData(result);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [getApiToken]);
  return (
    <QueueTotalsContext.Provider
      value={{
        loading: isLoading,
        data,
      }}
    >
      {children}
    </QueueTotalsContext.Provider>
  );
};
export default QueueTotalsContainer;
